<template>
    <v-app class="fill-height">
        <v-app-bar app clipped-left dense class="elevation-3" color="primary">
            <v-app-bar-nav-icon class="mx-1" href="/"><v-icon>mdi-home</v-icon></v-app-bar-nav-icon>
            <img src="/unifylogo.svg" class="pa-0 mr-3" height="15" @click="showChangelog = true" style="cursor: pointer" />
            <v-toolbar-title class="text-h6 pa-0 mr-3">Podcast Playa</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-menu bottom left offset-y open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mr-1" icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>

                <v-list dense nav>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">
                                {{ this.$auth.userProfile.name }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item link @click="$vuetify.theme.dark = !$vuetify.theme.dark">
                        <v-list-item-icon class="mr-3">
                            <v-icon>mdi-theme-light-dark</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $vuetify.theme.dark ? 'Light' : 'Dark' }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link @click="$auth.signOut()">
                        <v-list-item-icon class="mr-3">
                            <v-icon>mdi-logout-variant</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Sign Out</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-navigation-drawer app floating permanent clipped class="elevation-3" v-model="drawer" :mini-variant="$vuetify.breakpoint.smAndDown || collapseNavigation">
            <v-list dense nav>
                <v-list-item-group color="primary">
                    <v-list-item link exact :to="{ name: 'Podcasts' }">
                        <v-list-item-icon class="mr-3">
                            <!-- <v-icon>mdi-alpha-{{ this.$route.params.buildKey.charAt(0) }}-box-outline</v-icon> -->
                            <v-icon>mdi-podcast</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="primary--text font-weight-bold">{{ buildDescription }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- <v-list-item link exact :to="{ name: 'Podcasts' }">
                        <v-list-item-icon class="mr-3"><v-icon>mdi-podcast</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title>Podcasts</v-list-item-title></v-list-item-content>
                    </v-list-item> -->
                </v-list-item-group>
            </v-list>
            <template v-slot:append>
                <v-list dense nav v-if="!$vuetify.breakpoint.smAndDown">
                    <v-list-item @click="collapseNavigation = !collapseNavigation">
                        <v-list-item-icon class="mr-3">
                            <v-icon>{{ collapseNavigation ? 'mdi-arrow-expand' : 'mdi-arrow-collapse' }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Collapse</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </template>
        </v-navigation-drawer>
        <v-main class="fill-height">
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'BuiLd',
    data() {
        return {
            drawer: null,
            collapseNavigation: false,
            buildDescription: '',
        }
    },
    mounted() {
        this.initialize()
        this.fetchBuild()
    },
    methods: {
        initialize() {},
        async fetchBuild() {
            try {
                var response = await this.$directoryApi.builds.one(this.$route.params.buildKey)
                this.buildDescription = response.data.description
            } catch (err) {
                console.log(err)
            }
        },
    },
}
</script>
